import { render, staticRenderFns } from "./MOrderList.vue?vue&type=template&id=5e235a7e"
import script from "./MOrderList.vue?vue&type=script&lang=js"
export * from "./MOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports